import { render, staticRenderFns } from "./CreatModal.vue?vue&type=template&id=80e899f6&scoped=true"
import script from "./CreatModal.vue?vue&type=script&lang=ts"
export * from "./CreatModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80e899f6",
  null
  
)

export default component.exports